<template>
  <d-list-group flush>
    <d-list-group-item class="p-0">
      <d-row>

        <d-col class="form-group">
          <d-row>
            <!-- Roles filter -->
            <d-col md="4" class="form-group">
              <label for="feRoles">Tipos de usuário</label>
              <d-select v-model="role" @change="getPermissions()">
                <option :value="option.id" v-for="(option, index) in rolesList" :key="index">{{ option.name }}</option>
              </d-select>
            </d-col>
          </d-row>
          <d-form>
            <d-card class="card-small">
              <!-- Card Header -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Lista de Módulos</h6>
              </d-card-header>

              <d-card-body class="p-0 pb-1">
                <d-list-group>
                  <d-list-group-item v-for="(row, index) in permissionsList" :key="index" class="d-flex px-3 align-items-center border-bottom-0">
                    <d-col cols class="text-fiord-blue pl-0">
                      <h5 class="text-semibold mb-0">
                        {{ row.name }}
                      </h5>
                      <p class="m-0">{{ row.description }}</p>
                    </d-col>
                    <d-col cols="auto">
                      <d-checkbox toggle @change="toggleModule(row)" :checked="(row.active==1)" class="custom-toggle-sm">Sim</d-checkbox>
                    </d-col>
                  </d-list-group-item>
                  <d-list-group-item v-if="permissionsList.length == 0" class="border-bottom-0">
                    <h5 class="no-content">Selecione um departamento</h5>
                  </d-list-group-item>
                </d-list-group>
              </d-card-body>

            </d-card>
          </d-form>
        </d-col>

      </d-row>

    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import AccessControlService from '_services/rest/modules/accessControl';
import { OPTION } from '../SettingsModel';

export default {
  name: 'permission-form',
  components: {
  },
  data() {
    return {
      permissionsList: [],
      role: null,
    };
  },
  computed: {
    rolesList() {
      const { roles } = this.$store.state.settings;
      if (roles) {
        return roles;
      }
      return [{ ...OPTION }];
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    getPermissions() {
      setTimeout(() => {
        if (this.role) {
          AccessControlService.getPermissions(this.role)
            .then(response => {
              this.permissionsList = response;
            });
        }
      }, 5);
    },
    toggleModule(permission) {
      permission.active = !permission.active;
      AccessControlService.savePermissions(permission, this.role)
        .then(() => this.activeAlert({ message: 'Permissões salvas com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
    this.getPermissions();
  },
};
</script>
